import React from 'react'
import {framework_tool, component_tool} from "@/tool";

const {modelUtils} = framework_tool;
const {WizBrowserExport, WizButton, WizModal} = component_tool

import { WizTableForm } from '@/containers/common';
import { number } from 'prop-types';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
const organizationByNoFilterConfig = WizTableForm.Config.organizationByNoFilter(this, { apiParams: { state: 1 } })
const positionByNoFilterConfig = WizTableForm.Config.positionByNoFilter(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory(this, { apiParams: { state: 1 } })
const offlineProgramConfig = WizTableForm.Config.offlineProgram(this, { apiParams: { status: 1 } })

const questionConfig = WizTableForm.Config.question(this, { apiParams: { state: 1 } })
const questionTypeConfig = WizTableForm.Config.questionType(this, { apiParams: { state: 1 } })
const dealerConfig = WizTableForm.Config.dealer(this, { apiParams: { state: 1 } })
const examConfig = WizTableForm.Config.exam(this, { apiParams: { state: 1 } })
const programConfig = WizTableForm.Config.program(this, { apiParams: { state: 1 } })
const userIdentityConfig = WizTableForm.Config.userIdentity(this, { apiParams: { state: 1 } })
const surveyTempConfig = WizTableForm.Config.surveyTemp(this, { apiParams: { state: 1 } })
const classStudentSignConfig = WizTableForm.Config.classStudentSign(this, { apiParams: { state: 1 } })
const surveyConfig = WizTableForm.Config.survey(this, { apiParams: { state: 1 } })
const examTempConfig = WizTableForm.Config.examTemp(this, { apiParams: { state: 1 } })
const trainSiteConfig = WizTableForm.Config.trainSite(this, { apiParams: { state: 1 } })
const abilityCheckCategoryConfig = WizTableForm.Config.abilityCheckCategory(this, { apiParams: { state: 1 } })
const abilityCheckItemConfig = WizTableForm.Config.abilityCheckItem(this, { apiParams: { state: 1 } })
const workflowProcDefConfig = WizTableForm.Config.workflowProcDef(this, { apiParams: { state: 1 } })
const workflowAuditMethodConfig = WizTableForm.Config.workflowAuditMethod(this, { apiParams: { state: 1 } })
const classInfoConfig = WizTableForm.Config.classInfo(this, { apiParams: { state: 1 } })
const trainCenterConfig = WizTableForm.Config.trainCenter(this, { apiParams: { state: 1 } })
const planConfig = WizTableForm.Config.plan(this, { apiParams: { state: 1 } })
const auditConfig = WizTableForm.Config.audit(this, { apiParams: { state: 1 } })
const categoryInfoConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { state: 1 } })
const applyStudentRecordConfig = WizTableForm.Config.applyStudentRecord(this, { apiParams: { state: 1 } })
const applicationInfoConfig = WizTableForm.Config.applicationInfo(this, { apiParams: { state: 1 } })
const roleInfoConfig = WizTableForm.Config.roleInfo(this, { apiParams: { state: 1 } })
const topicConfig = WizTableForm.Config.topic(this, { apiParams: { state: 1 } })
const labelConfig = WizTableForm.Config.label(this, { apiParams: { state: 1 } })
const contentConfig = WizTableForm.Config.content(this, { apiParams: { state: 1 } })
const invitationConfig = WizTableForm.Config.invitation(this, { apiParams: { state: 1 } })
const trainPathCommentConfig = WizTableForm.Config.trainPathComment(this, { apiParams: { state: 1 } })
const applyConfig = WizTableForm.Config.apply(this, { apiParams: { state: 1 } })
const activityConfig = WizTableForm.Config.activity(this, { apiParams: { state: 1 } })
const certConfig = WizTableForm.Config.cert(this, { apiParams: { state: 1 } })
const subjectConfig = WizTableForm.Config.subject(this, { apiParams: { state: 1 } })
const organizationByUserConfig = WizTableForm.Config.organizationByUser(this, { apiParams: { state: 1 } })
const coursewareConfig = WizTableForm.Config.courseware(this, { apiParams: { state: 1 } })
const homeworkConfig = WizTableForm.Config.homework(this, { apiParams: { state: 1 } })
const classAideRemoteAuthConfig = WizTableForm.Config.classAideRemoteAuth(this, { apiParams: { state: 1 } })
const remoteAuthConfig = WizTableForm.Config.remoteAuth(this, { apiParams: { state: 1 } })
const taskConfig = WizTableForm.Config.task(this, { apiParams: { state: 1 } })
const liveConfig = WizTableForm.Config.live(this, { apiParams: { state: 1 } })
const seriesConfig = WizTableForm.Config.series(this, { apiParams: { state: 1 } })
const audienceGroupConfig = WizTableForm.Config.audienceGroup(this, { apiParams: { state: 1 } })
const pathConfig = WizTableForm.Config.path(this, { apiParams: { state: 1 } })
const pathStageConfig = WizTableForm.Config.pathStage(this, { apiParams: { state: 1 } })
const adjustPlanConfig = WizTableForm.Config.adjustPlan(this, { apiParams: { state: 1 } })
const voiceMsgpathConfig = WizTableForm.Config.voiceMsg(this, { apiParams: { state: 1 } })


export const mapStateToProps = ({nameSpace, method}, state, ownProps) => {
  const {pathReport,reportConfig} = state;
  //const list = modelUtils.getModelEntity(pathReport, `reportConfig@getDetailListByPage`);
  const selectOneDetailById = modelUtils.getModelEntity(reportConfig, `reportConfig@selectOneDetailById`);
  const showFieldList = selectOneDetailById.data && selectOneDetailById.data.showFieldList
  const searchList = selectOneDetailById.data && selectOneDetailById.data.searchFieldList
  return {
    dynamicColumns: Array.isArray(showFieldList) && showFieldList.length ? showFieldList : [],
    searchColumns: Array.isArray(searchList) && searchList.length ? searchList : []
  }
};

export const handleExport = ({title, column}, nextProps, nextState, key) => {
  const res = nextProps[key]
  const {success, data = {}, msg} = res
  const dynamicColumns = nextProps.selectOneDetailById.data.showFieldList
  if(dynamicColumns && dynamicColumns.length){
    dynamicColumns.forEach(e=>{
      //处理列表头
      let header = {
            headerName: e.fieldName,
            field: e.fieldCode,
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: {vertical: 'bottom', horizontal: 'left'},
            },
      }
      column.push(header);

    })
  }
  if (success) {
    //处理列表枚举值展示问题
    const rows = data.map(val => {
      for (const col in dynamicColumns) {
        if(dynamicColumns[col].enumsNew){
          let enumsNew = dynamicColumns[col].enumsNew
          let fieldCode = dynamicColumns[col].fieldCode
          for (var key in val) {
            if(key==fieldCode){
              enumsNew.forEach(e=>{
                if(e.code===val[key]){
                  val[key] = e.codeName
                }
              })
            }
          }
        }
      }
      return val
    })

    WizBrowserExport({
      title,
      sheetName: title,
      columns: column,
      rows,
      filename: title + '.xlsx',
    })
    return true
  } else {
    wizNotice.error(msg)
    return false;
  }
}

export function mergeColumns(columns, events) {
  const {dynamicColumns , searchColumns} = this.props
  let _dynamicColumns = [];
  dynamicColumns && dynamicColumns.length ? dynamicColumns.forEach(val => {
    let valNew = {}
    // 搜索类型 0:文本,1:数字,2:时间,3:枚举下拉框(固定支持多选),4:自定义插件(固定支持多选)
    switch(val.fieldType){
      case 3 : 
        // 接口返回枚举code类型不一致处理
        val.enumsNew = val.enums.map(e=>({
           code : !isNaN(Number(e.code)) ? Number(e.code): e.code,
           codeName : e.codeName
        }))
        valNew = {
                title: val.fieldName+'',
                name: val.fieldCode+'',
                tableItem: {
                },
                dict: val.enumsNew
              }
        break;
      default : 
        valNew = {
          title: val.fieldName+'',
          name: val.fieldCode+'',
          tableItem: {
          },
        }
    }
    _dynamicColumns.push(valNew);
  }):undefined;

  let _searchColumns = [];
  searchColumns && searchColumns.length ? searchColumns.forEach(val => {
    let valNew = {}
    // 搜索类型 0:文本,1:数字,2:时间,3:枚举下拉框(固定支持多选),4:自定义插件(固定支持多选)
    let typeId;
    if(val.fieldType==4){
      val.fieldType = val.fieldType + val.plugins;
      if(val.plugins.indexOf("categoryInfoConfig"!=-1)){
        typeId=val.plugins.substring('categoryInfoConfig'.length);
      }
    }
    switch(val.fieldType){
      case 0 : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {

                },
              }
        break;
      case 1 : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  type: 'number',
                  //min:1,
                  //max:99999999,
                  //precision:2,
                  // rules: [{
                  //   required: true,
                  // }],
                },
              }
        break;
      case 2 : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  type: 'date~',
                  showTime: true,
                  format: 'YYYY-MM-DD HH:mm',
                },
              }
        break;  
      case 3 : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  type: 'select',
                  mode:'multiple'
                },
                dict: val.enums
              }
        break;
      case 4+'organizationConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...organizationConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
      case 4+'positionConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...positionConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;  
        case 4+'userConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...userConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'organizationByNoFilterConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...organizationByNoFilterConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'positionByNoFilterConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...positionByNoFilterConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'positionCategoryConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...positionCategoryConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'offlineProgramConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...offlineProgramConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'questionConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...questionConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'questionTypeConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...questionTypeConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'dealerConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...dealerConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'examConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...examConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break; 
        case 4+'programConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...programConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'userIdentityConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...userIdentityConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'surveyTempConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...surveyTempConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'classStudentSignConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...classStudentSignConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'surveyConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...surveyConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'examTempConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...examTempConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'trainSiteConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...trainSiteConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'abilityCheckCategoryConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...abilityCheckCategoryConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'abilityCheckItemConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...abilityCheckItemConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'workflowProcDefConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...workflowProcDefConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'workflowAuditMethodConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...workflowAuditMethodConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'classInfoConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...classInfoConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'trainCenterConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...trainCenterConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'planConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...planConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'auditConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...auditConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'categoryInfoConfig'+typeId : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  //...categoryInfoConfig,
                  ...WizTableForm.Config.categoryInfo(this, { apiParams: { state: 1 ,type : typeId} }),
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'applyStudentRecordConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...applyStudentRecordConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'applicationInfoConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...applicationInfoConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'roleInfoConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...roleInfoConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'topicConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...topicConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'labelConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...labelConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'contentConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...contentConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'invitationConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...invitationConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'trainPathCommentConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...trainPathCommentConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'applyConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...applyConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'activityConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...activityConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'certConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...certConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'subjectConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...subjectConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'organizationByUserConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...organizationByUserConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'coursewareConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...coursewareConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'homeworkConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...homeworkConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'classAideRemoteAuthConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...classAideRemoteAuthConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'remoteAuthConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...remoteAuthConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'taskConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...taskConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'liveConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...liveConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'seriesConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...seriesConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'audienceGroupConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...audienceGroupConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'pathConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...pathConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'pathStageConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...pathStageConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'adjustPlanConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...adjustPlanConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
        case 4+'voiceMsgpathConfig' : 
        valNew = {
                title: val.name+'',
                name: val.key+'',
                searchItem: {
                  ...voiceMsgpathConfig,
                  diy: WizTableForm,
                  selectType: 'checkbox',
                },
              }
        break;
    }
    _searchColumns.push(valNew);
  }):undefined;

  return columns.concat(_dynamicColumns).concat(_searchColumns)
}
